import { QueryPersonalPropertyItemArgs } from '../generated/graphql';

export const personalPropertyItemKeys = {
  base: ['personalPropertyItemKeys'],
  personalPropertyItem: (args: QueryPersonalPropertyItemArgs) => [
    'personalPropertyItem',
    ...personalPropertyItemKeys.base,
    args,
  ],
};
